import React, { useEffect } from 'react';

function Startups() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Start-up <span className="hero__highlight">Recruiting Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Talente für Start-ups in Berlin: Junge Innovatoren, Gen Z über Social Media. Kreative und agile Recruiting-Strategien seit 2009.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Start-up Recruiting: Innovation trifft Talent in Berlin</h2>
            <p className="section-subtitle">
              Berlin ist die Start-up-Hauptstadt Europas. Bei famefact unterstützen wir Start-ups bei der Gewinnung von Talenten über innovative Social Media Strategien – von Entwicklern bis zu Marketing-Spezialisten.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>Warum Start-up-Recruiting in Berlin über Social Media erfolgreich ist</h3>
              <p>
                Berlin ist unbestritten die Start-up-Hauptstadt Europas. Mit über 3.500 aktiven Start-ups, mehr als 30 Unicorns und einem jährlichen Investment-Volumen von über 10 Milliarden Euro ist die Berliner Start-up-Szene so dynamisch wie nirgendwo sonst in Europa. Der War for Talent ist in der Start-up-Szene besonders intensiv.
              </p>
              <p>
                Social Media ist der natürliche Habitat der Start-up-Generation. Unsere Strategie basiert auf: <strong>Authentisches Storytelling, virale Content-Formate, Gen Z-Ansprache und schnelle Execution.</strong> Wir verstehen, dass Start-up-Talente nicht nur einen Job suchen – sie suchen eine Mission.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">12-20€</span>
                  <span className="stat-box__label">Pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">3.500+</span>
                  <span className="stat-box__label">Aktive Start-ups</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">30+</span>
                  <span className="stat-box__label">Unicorns</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">10B€</span>
                  <span className="stat-box__label">Investment-Volumen</span>
                </div>
              </div>

              <h3>Unsere Start-up Recruiting Services</h3>
              
              <h4>1. Tech-Talente und Entwickler</h4>
              <ul>
                <li>Full-Stack und Frontend Entwickler</li>
                <li>Backend und DevOps Engineers</li>
                <li>Product Designer und UX Specialists</li>
                <li>Data Scientists und AI Engineers</li>
              </ul>

              <h4>2. Marketing und Growth Talente</h4>
              <ul>
                <li>Growth Hacker und Performance Marketer</li>
                <li>Content Creator und Social Media Manager</li>
                <li>Brand Manager und Creative Directors</li>
                <li>SEO und SEM Specialists</li>
              </ul>

              <h4>3. Business und Operations Talente</h4>
              <ul>
                <li>Business Development Manager</li>
                <li>Operations und Project Manager</li>
                <li>Finance und HR Specialists</li>
                <li>Sales und Customer Success</li>
              </ul>

              <div className="cta-box">
                <h3>Kostenlose Start-up-Analyse</h3>
                <p>Vereinbaren Sie Ihre kostenlose Analyse für Start-up-Recruiting.</p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Start-up-Positionen</h3>
                <ul>
                  <li>✓ Entwickler</li>
                  <li>✓ Marketer</li>
                  <li>✓ Business Developer</li>
                  <li>✓ Designer</li>
                  <li>✓ Innovatoren</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@famefact.com">info@famefact.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Startups;
